import { render, staticRenderFns } from "./ListVaccinationArea.vue?vue&type=template&id=a5edbac8&scoped=true&"
import script from "./ListVaccinationArea.vue?vue&type=script&lang=js&"
export * from "./ListVaccinationArea.vue?vue&type=script&lang=js&"
import style0 from "./ListVaccinationArea.vue?vue&type=style&index=0&id=a5edbac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5edbac8",
  null
  
)

export default component.exports